exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "table#classGenTable{margin-top:15px;width:100%}table#classGenTable input.name{width:300px}table#classGenTable td{padding-bottom:10px;padding-right:5px}table#classGenTable .grade{min-width:60px}#addClassModal .modal-dialog{width:418px}#addClassModal .withEmail .modal-dialog{width:700px}#addClassModal .studentListDropDown{position:absolute}#addClassModal .addClassColumnHeader{font-weight:700}#addClassModal a.clear{position:relative;vertical-align:middle;left:81px}#addClassModal .buttonSuccess{margin:30px auto 0;display:block!important}#addClassModal .manualView{padding-right:3px}#addClassModal .manualView .addNewClassForm .inputContainer{width:266px}#addClassModal .manualView .addNewClassForm .inputContainer.gradeLevel{width:56px}#addClassModal #addRow{float:right;position:relative;right:5px;color:#337ab7}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/org/roster/add_new_class_modal.scss
// module id = 864
// module chunks = 0